import React, { useEffect } from 'react'
import { useState } from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap'
import ReferPractitionerSearchField from '../Practitioner/ReferPractitionerSearchField';
import { FAILTOSAVERECOED } from 'utils/Constants';
import { ReferralService } from 'utils/ReferralService';
import swal from "sweetalert";
import { withAlert } from 'react-alert';
import { PractitionerService } from 'utils/PractitionerService';
import { showErrorMessage, showSuccessMessage } from 'common/AlertContainer';

export default withAlert()(function ReferAssignModal(props) {
  const { referral, getReferralById, getAssignmentHistory, alert } = props;
  const [selectedOption, setSelectedOption] = useState(null);
  const [practitioners, setPractitioners] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const getAllPractitioner = (guid) => {
    PractitionerService.getPractitionersAssociatedtoInstitutionWithPagination(guid)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          if (referral?.referredToPhysician?.profileGuid) {
            const filteredPractitioners = data.contents.filter((practitioner) => practitioner.profileGuid !== referral.referredToPhysician.profileGuid);
            setPractitioners(filteredPractitioners);
          } else {
            setPractitioners(data.contents);
          }
        } else {
          console.log("Something went wrong");
        }
      });
  }


  useEffect(() => {
    getAllPractitioner(referral?.referredToInstitution?.guid)
  }, [referral])

  useEffect(() => {
    if(selectedOption?.value)
    setErrorMessage("")    
  }, [selectedOption?.value])
  

  const confirmAndUpdateAssignee = (e) => {
    e.preventDefault();
    if (selectedOption?.value && selectedOption?.value !== "") {
      setErrorMessage("");
      swal("Are you sure you want to change the Assignee?", {
        buttons: ["Cancel", "Yes"],
      })
        .then((yes) => {
          if (yes)
            updateReferralAssignee();
        })
    } else {
      setErrorMessage("Please select Practitioner to assign");
      // showErrorMessage("Please select Practitioner to assign");
    }
  }


  const updateReferralAssignee = () => {
    const payload = {
      "referredToPhysician": {
        "profileGuid": selectedOption?.value
      }
    }

    ReferralService.updateReferral(referral?.id, payload, 'RECEIVED')
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          showSuccessMessage(`Referral Assignee updated Successfully.`);
          getReferralById(referral?.id);
          getAssignmentHistory(referral?.id);
          setSelectedOption(null);
        }
        else {
          showErrorMessage(FAILTOSAVERECOED);
        }
      })
  }
  return (
    <Modal isOpen={props.open} toggle={() => props.setToggle(!props.open)}>
      <ModalHeader toggle={() => props.setToggle()}><span className="nex-text-xl">Assign To</span></ModalHeader>
      {practitioners && practitioners.length > 0 ?
        <ModalBody>
          <ReferPractitionerSearchField label="Select Practitioner" referral={referral}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            practitioners={practitioners}
          />
          {errorMessage && <p className="text-danger small">{errorMessage}</p>}
          <div className="justify-content-end  modal-footer mt-5 mb-3">
            <div className="action-group">
              <Button id="raf_btn_save" className="modal-save-btn nex-btn-primary" color="secondary " type="button" onClick={(e) => confirmAndUpdateAssignee(e)}>Assign</Button>
              <Button id="raf_btn_cancel" className="modal-cancel-btn nex-btn-primary-outline" color="primary " type="button" onClick={() => props.setToggle(!props.open)}>Cancel</Button>
            </div>
          </div>
        </ModalBody>
        :
        <div className='nexogic-nodata-dotted m-4'>
          <div className='no-suggestion-text text-center m-4 p-5'>There are no more practitioners available to assign a referral.</div>
        </div>
      }
    </Modal>
  )
}
);